import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Start from '@/components/pages/Start'
import ManageApplication from '@/components/pages/applications/ManageApplication'
import NewApplicationRequest from '@/components/pages/applications/NewApplicationRequest'
import Menu from '@/components/partials/Menus/Menu'
import Demo from '@/components/pages/Demo'
import Register from '@/components/pages/registration/Register'
import Success from '@/components/misc/Success'
import StatusNotAuth from '@/components/misc/status-notAuth'
import Auth from '../plugins/Auth'
import Base from '../plugins/factory/BaseExtensions'
import Properties from '../../static/properties/appConfig'
import SearchCategory from '@/components/pages/applications/SearchCategory'
import ApplicationRequest from '@/components/pages/applications/ApplicationRequest'
import UsersRegistrationRequests from '@/components/pages/organization/UsersRegistrationRequests'
import Dashboard from '@/components/pages/Dashboard'
import Profile from '@/components/pages/Profile'
import Status from '@/components/pages/Status'
import History from '@/components/pages/History'
import Pairing from '@/components/pages/pairing'
import org from '@/components/pages/org'
import userLogin from '@/components/pages/registration/userLogin'
import InternalStatus from '@/components/pages/InternalStatus'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        authRequired: true,
        accessRequired: true
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/misc/success',
      name: 'Success',
      component: Success
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/start',
      name: 'Start',
      component: Start,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        authRequired: true,
        accessRequired: true
      }
    },
    {
      path: '/status',
      name: 'Status',
      component: Status,
      meta: {
        authRequired: true,
        accessRequired: true
      }
    },
    {
      path: '/history',
      name: 'History',
      component: History,
      meta: {
        authRequired: true,
        accessRequired: true
      }
    },
    {
      path: '/pairing',
      name: 'Pairing',
      component: Pairing,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/comments',
      name: 'Comments',
      component: InternalStatus,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/org',
      name: 'org',
      component: org,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/userLogin',
      name: 'userLogin',
      component: userLogin,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/applications/manage',
      name: ManageApplication,
      component: ManageApplication,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/applications/request',
      name: NewApplicationRequest,
      component: NewApplicationRequest,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/applications/search',
      name: SearchCategory,
      component: SearchCategory,
      props: (route) => ({ category: route.query.category }),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/applications/review',
      name: ApplicationRequest,
      component: ApplicationRequest,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/applications/review',
      name: ApplicationRequest,
      component: ApplicationRequest,
      meta: {
        authRequired: true
      }
    },
    {
      path: '/organization/requests/userRequests',
      name: UsersRegistrationRequests,
      component: UsersRegistrationRequests,
      meta: {
        authRequired: true
      },
      beforeEnter: (to, from, next) => {
        if (!store.getters.isAdmin && localStorage.getItem('isAdmin') === null && !Base.isPermitted(Properties.properties.accessToSecurityAndExchangeAdmins)) {
          next('/404')
        } else {
          next()
        }
      }
    },
    {
      path: '/404',
      name: '404',
      component: StatusNotAuth,
      meta: {
        authRequired: true
      }
    }

  ]
})

let lastRouteName = ''

router.afterEach(to => {
  // eslint-disable-next-line no-undef
  if (to.name === null) {
    localStorage.setItem('LS_ROUTE_KEY', lastRouteName)
  } else {
    localStorage.setItem('LS_ROUTE_KEY', to.name)
  }
})

router.beforeEach((to, from, next) => {
  lastRouteName = localStorage.getItem('LS_ROUTE_KEY')
  const authRequired = to.matched.some(page => page.meta.authRequired)
  const accessRequired = to.matched.some(page => page.meta.accessRequired)
  console.log('page', to.matched, accessRequired, lastRouteName)

  if (authRequired) {
    if (accessRequired) {
      console.log('page1', to, Base.canAccess())
      if (Base.canAccess()) {
        next()
      } else if (Base.canAccessPairinig()) {
        next('/pairing')
      } else if (localStorage.getItem('AUTHENTICATED') === null || localStorage.getItem('AUTHENTICATED') === 'false') {
        Auth.authCheck(to)
      } else if (Base.canAccessNoRole()) {
        next('/profile')
      } else {
        next()
      }
    } else {
      console.log('page11', to, from, Base.canAccess())
      next()
    }
  } else if (authRequired && !store.getters.isAuth && (localStorage.getItem('AUTHENTICATED') === null || localStorage.getItem('AUTHENTICATED') === 'false')) {
    Auth.authCheck(to)
  } else if (store.getters.isAuth && to.name === null && to.path !== '/auth') {
    if (accessRequired) {
      console.log('page3', to, Base.canAccess())
      if (Base.canAccess()) {
        next('/dashboard')
      } else {
        next('/pairing')
      }
    } else {
      console.log('page4', to, Base.canAccess())
      next('/profile')
    }
  } else if (!store.getters.isAuth && to.name === null && to.path !== '/auth') {
    if (accessRequired) {
      if (Base.canAccess()) {
        next()
      } else if (Base.canAccessPairinig()) {
        next()
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    if (accessRequired) {
      console.log('page5', to, Base.canAccess())
      if (Base.canAccess()) {
        next()
      } else {
        next('/pairing')
      }
    } else {
      console.log('page6', to, Base.canAccess())
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js